import React from "react";
import styled from "styled-components";

import themeGet from "@/utils/theme-gets";

import type { VirtualizeOptionProps } from "../../../models/VirtualizeOptionStyle";
import { DropdownLoader } from "./DropdownLoader";

type LoaderOptionProps = {
  text: string;
};

export const LoaderOption: React.FC<LoaderOptionProps & VirtualizeOptionProps> = ({ virtualizedStyle, text }) => {
  return (
    <LoaderOptionWrapper style={virtualizedStyle}>
      <LoaderOptionText>{text}</LoaderOptionText>
      <DropdownLoader />
    </LoaderOptionWrapper>
  );
};

const LoaderOptionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${themeGet("spacing.s")} calc(${themeGet("spacing.m")} + ${themeGet("spacing.s")});
`;

const LoaderOptionText = styled.span`
  color: ${themeGet("color.foreground.text.secondary")};
  font: ${themeGet("typography.body.bolder.s")};
`;
